/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
// Stellar Init

export const initCheetah = () => {
    window.stellarEnvironments = {
        production: {
            domains: ['donatos.com', 'www.donatos.com'],
            config_url: '//www.donatos.com/js/config-prod.js',
        },
        staging: {
            domains: ['uat.donatoslabs.com'],
            config_url: '//uat.donatoslabs.com/js/config-uat.js',
        },
        uat: {
            domains: ['uat.donatoslabs.com'],
            config_url: '//uat.donatoslabs.com/js/config-uat.js',
        },
        development: {
            domains: ['dev.donatoslabs.com'],
            config_url: '//dev.donatoslabs.com/js/config-dev.js',
        },
        localhost: {
            domains: ['localhost', 'localhost:8080', 'localhost:8081'],
            config_url: '//localhost:8080/js/config-local.js',
        },
    };
    var rewardsApplyData = null;
    window.Stellar = window.Stellar || {};
    window.Stellar.dataLoaded = false;
    window.Stellar.activities = {};

    // Run Stellar
    // This function is called when your environment and the Stellar JS SDK are loaded and ready to run.
    //
    // The JS SDK will be available in the "Stellar" namespace, and you can run custom code here as needed.
    // If you want to abort the standard loading then *return true* from this function .
    //
    // If you do not need custom code, just leave the function empty or comment it out. The default is:
    window.runStellar = () => false;

    window.stellarReady = function () {
        // initialize progressBar
        Stellar.events.bind('contentTokens.loaded', () => Stellar.ui.progressBar());

        // Event listener for challenge complete
        Stellar.events.bind('challenge.completed', function (a, b) {
            Stellar.api.rebuildOffers(); // call the rebuild offers
            // window.Stellar?.ui?.refresh();
        });

        Stellar.tmpl.challengeResponseSuccess = function (item, response) {
            let responseMessage = 'Thank You!';
            if (item?.responseBody) {
                responseMessage = item.responseBody.replace('p>', 'span>');
            } else if (item?.response_message) {
                responseMessage = item.response_message;
            }
            return `<div class="stellar-response-content">
              <div class="stellar-response-content-wrap">
                <div class="stellar-response-content-wrap-inner">
                <div class="stellar-response-msg" style="display: none;"></div>
                  <div style="text-align: center">
                    <p style="font-size: 1.2em; font-weight: bold;">${responseMessage}</p>
                  </div>

                  <div class="stellar-btn-container">
                    <button class="stellar-btn stellar-btn-primary stellar-btn-ok ">OK</button>
                  </div>
                </div>
              </div>
          </div>
          `;
        };

        // New Add Stellar Event Bind
        Stellar.events.bind('rewards.loaded', function () {
            Stellar.tmpl.redemptionSuccess = function (item) {
                rewardsApplyData = item;
                let responseMessage = 'Success!';
                if (item?.extra_json?.category == 'on_demand') {
                    let responseContent = 'Your reward has been issued.';
                    return `<div class="stellar-response-content">
            <div class="stellar-response-content-wrap">
              <div class="stl-align-center">
                <h1 class="stl-bold">${responseMessage}</h1>
                <h4 class="stl-bold-black"><b>${responseContent}</b></h4>
                <img class="stellar-img" src="rewardsPep.png"  alt="pepGuy" /> <br/><br/>
                <div class="stellar-btn-container frist-donatos-btn" onclick="handleRewardClick()"></div>
                <div class="reward-actions">
                <button class="stellar-btn stellar-btn-ok"></button>
                </div>
              </div>
            </div>
          </div>`;
                } else if (item?.extra_json?.category == 'sweepstakes') {
                    let responseContent = 'You Have been entered into the drawing.';
                    let responseContentSecond = 'Winners will be notified by email on or around ';
                    let date = item?.extra_json?.date;
                    let details = item?.details;

                    return `<div class="stellar-response-content">
          <div class="stellar-response-content-wrap">
            <div class="stl-align-center">
              <h1 class="stl-bold">${responseMessage}</h1>
              <h4 class="stl-bold-black">${responseContent}</h4>
              <h4 class="stl-bold-black">${responseContentSecond} ${date}.</h4>
              <img class="stellar-img" src="rewardsPep.png"  alt="pepGuy" />

              <div class="stellar-btn-container second-donatos-btn"></div>
              <div class="reward-actions">
                <div class="rewards-text">${details}</div>
              </div>
            </div>
          </div>
        </div>`;
                } else {
                    let responseMessage = 'Redemption Successful';
                    let responseContent = 'Redemption has been Successful';
                    return `<div class="stellar-response-content">
          <div class="stellar-response-content-wrap">
            <div class="stl-align-center">
              <h1 class="stl-bold">${responseMessage}</h1>
              <h4 class="stl-bold-black">${responseContent}</h4>     <br/><br/>
              <div class="stellar-btn-container third-donatos-btn"></div>
            </div>
          </div>
        </div>`;
                }
            };
        });

        // fetch activities for user
        const allowedTypes = [
            'badge_bonus_4',
            'badge_bonus_3',
            'badge_bonus_2',
            'badge_bonus',
            'earn_referrer_points',
            'import_redeem',
            'points_bonus_1',
            'points_bonus_2',
            'points_bonus_3',
            'points_bonus_4',
            'sl_adjust_earn',
            'sl_adjust_redeem',
            'sl_badge',
            'sl_cancel_earn',
            'sl_cancel_redeem',
            'sl_challenge',
            'sl_claim',
            'sl_contest',
            'sl_expire',
            'sl_follow',
            'sl_offer',
            'sl_purchase',
            'sl_referral',
            'sl_reprocess',
            'sl_reward',
            'sl_submit',
            'sl_survey',
            'earn_adjustment',
        ];

        function handleActivitiesData(data) {
            window.Stellar.activities = data;
            window.Stellar.dataLoaded = true;
        }

        Stellar.api.callActivities(
            {
                period: 'last12m',
                with_detail: true,
                with_metric_change: true,
                per_page: 100,
                allowed_types: allowedTypes.join(','),
            },
            handleActivitiesData
        );
    };

    // START TEMPLATES
    // Template Override Docs
    // https://docs.cheetahces.com/en-us/loyalty/developer/sdk/js_sdk/07_override_ui_templates.html

    const addFooter = (detail) => {
        return `<p class="mt-0 mb-4 cheetah-footer">${detail}</p>`;
    };

    //======== new Add handleRewardClick Methods
    window.handleRewardClick = () => {
        let rewardsData = rewardsApplyData;
        const onChangeRewardsApply = new CustomEvent('onChangeRewardsApply', { detail: rewardsData });
        window.dispatchEvent(onChangeRewardsApply);
    };

    // Active rewards full list: RewardMenuPage.vue
    window.rewardTemplate = (item) => {
        return `<div data-reward-id="${item.id}" class="stl_content cheetahCard cheetahThreeCol">
    <div  class="stl_action full-height" >
      <div class="stl_image1" >
        <img src="${item.image_url}" class="image-ratio-square">
      </div>

      <div class="stl_body px-8 ion-text-center" >
        <h2 class="my-0 color-primary">${item.heading}</h2>
        <h6 class="my-0 color-medium">${item.subheading}</h6>
        <b>${item.metric_amount} ${item.metric_display_name}</b>
        <p>${item.body}</p>

        ${item.details ? addFooter(item.details) : ''}
      </div>

      </div>
    </div>`;
    };

    // Inactive rewards full list: rewardMenuPage.vue
    window.inactiveRewardTemplate = (item) => {
        return `<div data-reward-id="${item.id}" class="stl_content cheetahCard cheetahThreeCol disabled">
    <div  class="stl_action full-height" >
      <div class="stl_image1" >
        <img src="${item.image_url}" class="image-ratio-square">
      </div>

      <div class="stl_body px-8 ion-text-center" >
        <h2 class="my-0 color-primary">${item.heading}</h2>
        <b>${item.metric_amount} ${item.metric_display_name}</b>
      </div>

      </div>
    </div>`;
    };

    // Scrolling Rewards list: scrollCheetahRewards.vue
    window.inlineRewardTemplate = (item) => {
        return `
    <div class="stl_content inlineCheetah cheetahCard">
    <div data-reward-id="${item.id}" class="stl_action full-height" >
      <div class="stl_image1" >
        <img src="${item.image_url}" class="image-ratio-square">
      </div>

      <div class="stl_body px-8" >
        <p class="my-0 wrap-text">${item.heading}</p>
        <b>${item.metric_amount} ${item.metric_display_name}</b>
      </div>

      </div>
    </div>
    `;
    };

    // Badge Template: rewardDetail.vue
    window.badgeTemplate = (item) => {
        return item.earned && !item.expired
            ? `
        <div class="stl_content stellar-contentvis stl_not_respondable pa-6" role="button" data-badge-id="${item.id}">
          <div class="stellar-badges-box">
          <img src="${item.image_url}" alt="${item.label}">
          <div>${item.label}</div>
          </div>
        </div>
        `
            : '';
    };

    // Challenges.Offer Template: bonusPointsPage.vue
    // using cheetah's default html, adding data-offer-id to template
    window.offerTemplate = (item) => {
        item.html = item.html.replace(/<div\s/, `<div data-offer-id="${item.id}" `);
        return item.html;
    };

    // END TEMPLATES

    // Stellar Init
    // Copyright (c) 2016 Stellar Loyalty, Inc. All Rights Reserved
    //
    // This script bootstraps the Stellar JS SDK
    // 1. detect environment
    // 2. load environment-specific config.js
    // 3. config.js calls window.stellarLoadApp to load JS SDK
    // 4. window.stellarLoadApp calls window.stellarAsyncInit to load web app
    //
    (function () {
        if (typeof window.stellarInitOpts == 'undefined') {
            window.stellarInitOpts = { context: '', isDefault: true };
        }

        // HardCoded value for native app:
        // env = "production";

        var host = location.hostname;
        var env = 'production';

        if (host.indexOf('dev.') === 0) {
            env = 'development';
        } else if (host.indexOf('localhost') === 0 || host.indexOf('sdk.') === 0) {
            env = 'localhost';
        } else if (host.indexOf('uat.') === 0 || host.indexOf('demostellar.com') !== -1 || window.stellarEnvironments.staging.domains.indexOf(host) !== -1) {
            // staging and uat are the same
            env = 'staging';
        } else {
            env = 'production';
        }
        window.stellarInitOpts.environment = env;

        window.stellarScriptLoader = function (d, s, id, src, dm, successCallback = () => false) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = src;
            if (dm) {
                js.setAttribute('data-main', dm);
            }

            if (js.readyState) {
                el.onreadystatechange = function () {
                    if (el.readyState == 'loaded' || el.readyState == 'complete') {
                        el.onreadystatechange = null;
                        successCallback();
                    }
                };
            } else {
                js.onload = successCallback;
            }
            fjs.parentNode.insertBefore(js, fjs);
        };
        // calls window.stellarLoadApp
        window.stellarScriptLoader(document, 'script', 'stellar-config', window.stellarEnvironments[window.stellarInitOpts.environment].config_url);

        window.stellarLoadApp = function (config) {
            window.stellarConfig = config;

            config.environment = config.environment || window.stellarInitOpts.environment;
            if (config.environment !== window.stellarInitOpts.environment) {
                console.log('WARNING - detected environment does not match configuration');
            }
            // calls window.stellarAsyncInit
            window.stellarScriptLoader(document, 'script', 'stellar-sdk', config.client.sdk);
        };

        window.stellarAsyncInit = function () {
            if (typeof window.runStellar === 'undefined') {
                window.runStellar = () => false;
            }
            if (typeof window.stellarReady === 'undefined') {
                window.stellarReady = () => false;
            }
            Stellar.initOpts(window.stellarConfig);
            if (!window.runStellar(window.stellarConfig)) {
                Stellar.init(window.stellarConfig, function () {
                    window.stellarReady();
                    Stellar.ui.refresh();
                });
                if (window.stellarConfig.themeUrl) {
                    stellarScriptLoader(document, 'script', 'stellar-theme', window.stellarConfig.themeUrl);
                }
            }
        };
    })();
};
